import { styled } from '@mui/system';

const Offset = styled('div')(({ theme }) => theme.mixins.toolbar);

export default Offset